import './App.css';
import {
  createBrowserRouter,
  RouterProvider
} from "react-router-dom";
import Home from './layout/home/Home';
import Resources from './layout/resources/Resources';


const router = createBrowserRouter([
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/resources",
    element: <Resources />,
  },
  {
    path: "*",
    element: <Home />,
  },
]);

function App() {
  return (
    <RouterProvider router={router} />
  );
}

export default App;
